import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { createUserWithEmailAndPassword, sendEmailVerification, updateProfile } from 'firebase/auth';
import { auth, db, provider } from './firebase-config';
import { addDoc, getDocs, collection, onSnapshot, doc, deleteDoc } from 'firebase/firestore';
import swal from 'sweetalert';
import './SignUp.css'

import { useNavigate } from 'react-router-dom';





function SignUp({ }) {

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


    //Sign Up
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [username, setUsername] = useState("")
    let navigate = useNavigate();

    //database
    const userCollectionRef = collection(db, "users");

    async function writeToDB() {
        try {

            await addDoc(userCollectionRef, {
                email,
                password,
                username,
                favoriteGame: "undediced",
                author: { name: auth.currentUser.displayName, id: auth.currentUser.uid }
            });
        } catch (err) {
            console.error("writeToDB failed. reason:", err);
        }
    }


    const signUp = () => {
        createUserWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                // Signed in 
                const user = userCredential.user;

                //updateUsernae
                updateProfile(auth.currentUser, {
                    displayName: username,
                }).then(() => {
                    // Profile updated!
                    // ...
                }).catch((error) => {
                    // An error occurred
                   swal("Oops!", "An error occured while Signing Up. Please try again.", "error")
                });


                // console.log(user);
                // alert("Successfully created an account");
                localStorage.setItem("isAuth", true);
                localStorage.setItem("user", auth.currentUser.displayName);
                localStorage.setItem("email", auth.currentUser.email);

                writeToDB();
                // setIsAuth(true);
                // document.getElementById("modal").setShow(false);
                swal("Awesome! You're Signed Up!", "You can now log in", "success")
                navigate("/");
                // ...
            })
            .catch((error) => {
                const errorCode = error.message;
                // const errorMessage = error.message;
                swal("Ooops!",errorCode, "error")
                // ..
            });


    }


    return (
        <>
            <p onClick={handleShow} style={{color: "blue", fontWeight: "bold", cursor: "pointer"}}>SignUp</p>

            <Modal
                id="modal"
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title className='SignUpHeader'>Sign Up</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h3>Your email address</h3>
                    <input type={"email"} placeholder="please enter your email" onChange={(e) => setEmail(e.target.value)} />
                    <h3>Username</h3>
                    <input type={"DislayName"} placeholder="create a username" onChange={(e) => setUsername(e.target.value)} />
                    <h3>Password</h3>
                    <input type={"password"} placeholder="please enter your password" onChange={(e) => setPassword(e.target.value)} />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={signUp}>Sign Up</Button>
                    <p> By creating an account you agree to our Terms and Conditions </p>

                </Modal.Footer>
            </Modal>
        </>
    );
}

export default SignUp;